function p(t, e) {
  const r = t.charCodeAt(e);
  let n;
  return r >= 55296 && r <= 56319 && t.length > e + 1 && (n = t.charCodeAt(e + 1), n >= 56320 && n <= 57343) ? t.substring(e, e + 2) : t[e];
}
function A(t, e) {
  return t[e];
}
function b(t, e) {
  return t - e;
}
function C(t, e, r = !1) {
  const n = r ? p : A, c = e.filter((u, h, g) => g.lastIndexOf(u) !== h ? !1 : u < t.length && u > 0).sort(b);
  if (c.length === 0)
    return /* @__PURE__ */ new Map([[0, t]]);
  const l = /* @__PURE__ */ new Map();
  let o = "", i = 0, s = 0, a = 0, f = 0;
  for (; s < t.length; ) {
    const u = n(t, s);
    o += u, s += u.length, i += 1, c[a] === i && (l.set(f, o), o = "", f = c[a], a += 1);
  }
  return o && l.set(f, o), l;
}
function I(t, e, r, n) {
  const c = t.substring(0, r), l = t.substring(n);
  return `${c}${e}${l}`;
}
function S(t) {
  return t.replace(/\\/g, "/");
}
function d(t) {
  return !!t || t === "true" || t === "1";
}
function w(t) {
  return !t || t === "false" || t === "0";
}
export {
  w as isFalseString,
  d as isTrueString,
  S as normalizeSlashes,
  I as replaceRange,
  C as splitByIndices,
  p as unicodeCharAt
};
